module.exports = __webpack_public_path__ + "img/esolexams.jpg?99faa06847f557043073a51bd5484745";